import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const SidebarButton = styled(Flex.withComponent('a') as any)<
  ISidebarButtonProps
>`
  height: ${({ size }) => (size ? 56 * size : 56)}px;
  width: 240px;
  padding: 0 ${({ size }) => (size ? 1.25 * size : 1.25)}em;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  position: relative;
  cursor: pointer;
  transition: all .2s ease-in-out;

  ${isLink}

  ${is('top')``}
  ${is('bottom')`
    border-top: 1px solid ${(props: ITheme) =>
      props.theme.colors.palette.greyTwo};;
  `}

  &:hover {
    background: #e1e1e1;
  }

  & > i,
  & > svg {
    padding: 0 ${({ size }) => (size ? 0.75 * size : 0.75)}em 0 ${({ size }) =>
  size ? 0.5 * size : 0.5}em;
    width: ${({ size }) => (size ? 45 * size : 45)}px;
    height: ${({ size }) => (size ? 40 * size : 40)}px;
    margin-left: ${({ size }) => (size ? -0.5 * size : -0.5)}em;

    &:hover {
      color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    }
  }

  & > img.small-logo {
    display: none;
  }

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    & > i,
    & > svg {
      display: none;
    }
  }
`

export default SidebarButton

export interface ISidebarButtonProps {
  bottom?: boolean
  top?: boolean
  size?: number
}
